import { getBidDetailService, getLatestAuctionOffersService } from "../services/auctionService";

export const singleProductMixin = {
    data() {
        return {
            astaId: '',
            bidDetail: {},
            type: 'single',
            latestAuctionOffers: [],
        };
    },
    props: {
        _astaCorrente: {
            type: Array,
            default: []
        },
        _id: {
            type: Number,
            required: true,
        },
        _prodotto: {
            type: String,
        },
        immagine: {
            type: Array,
        },
        currentBid: {
            type: Number,
        },
        prezzo: {
            type: Number,
        },
        colore: {
            type: Date,
        },
        dimensioni: {
            type: String,
        },
        taglia: {
            type: String,
        },
        descrizione: {
            type: String,
        }
    },
    computed: {
        didAuctionEnd() {
            if(this.type == "auction"){
                const endDate = this.bidDetail?.dataFine;
                return new Date(endDate) > new Date()
            }
            return false;
        },
        productType() {
            return this.type;
        },
        isAuctionProduct() {
            return this._astaCorrente.length > 0;
        }
    },
    mounted() {
        this.initSingleProductMixin();
    },
    methods: {
        async initSingleProductMixin() {
            var isAuctionProduct = this.isAuctionProduct;
            if(isAuctionProduct){
                this.type = 'auction';
                this.astaId = this._astaCorrente?.[0];
                await this.getBidDetail();
                await this.getLatestAuctionOffers();
            }
        },
        async getBidDetail() {
            let astaId = this.astaId;
            if (!astaId) return;

            let res = await getBidDetailService({
                astaId: astaId
            });
            this.bidDetail = res.asta || {};
        },
        async getLatestAuctionOffers() {
            let res = await getLatestAuctionOffersService({ "astaId": this.astaId});
            this.latestAuctionOffers = res.offerte || [];
        },
    }
}
